class CartDrawer extends HTMLElement {
  constructor() {
    super();
    window.FoxTheme = window.FoxTheme || {};
    window.FoxTheme.Cart = this;
    this.drawer = this.closest("drawer-component");
    window.FoxTheme.CartDrawer = this.drawer;
    this.openWhenAdded = this.dataset.openWhenAdded === "true";

    document.addEventListener("MAKEBECOOL_BUNDLES.updateCart", this.refreshCart.bind(this, true));
    document.addEventListener("MAKEBECOOL_BUNDLES.applyShopifyDiscount", this.refreshCart.bind(this, false));
  }

  connectedCallback() {
    window.FoxThemeEvents.subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      async (state) => {
        this.renderContents(state);
      }
    );
  }

  refreshCart(open) {
   const url = '/?sections=' + this.getSectionsToRender(true).map(sections => sections.id).join(',');
   fetch(url)
    .then(response => response.json())
    .then(sections => {
        this.classList.contains('is-empty') && this.classList.remove('is-empty');
      
        this.getSectionsToRender(true).forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
    
          if (!sectionElement) return;
          sectionElement.innerHTML = this.getSectionInnerHTML(sections[section.id], section.selector);

          setTimeout(() => {
            open && this.drawer.openDrawer();
          });
        });
    })
  }

  renderContents(parsedState, renderFooter = true) {
    if (parsedState.item_count !== 0) {
      this.classList.contains("is-empty") && this.classList.remove("is-empty");
    }
    this.getSectionsToRender(renderFooter).forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      if (this.openWhenAdded && !this.drawer.isOpen()) {
        this.drawer.openDrawer();
        document.body.classList.add("prevent-scroll");
        window.FoxThemeEvents.emit(`ON_CART_DRAWER_OPEN`, parsedState);
      }
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender(renderFooter = false) {
    const sections = [
      {
        id: "cart-drawer",
        selector: ".f-cart-drawer__items",
      },
      {
        id: "cart-drawer",
        selector: ".f-drawer__header",
      }
    ];

    if (renderFooter) {
      sections.push({
        id: "cart-drawer",
        selector: ".f-drawer__footer",
      });
    }

    return sections;
  }
}
customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  initLoading() {
    this.loading = new window.FoxTheme.AnimateLoading(
      document.querySelector("cart-drawer"),
      { overlay: document.querySelector("cart-drawer") }
    );
  }
  getSectionsToRender() {
    return [
      {
        id: "Drawer-Cart",
        section: "cart-drawer",
        selector: ".f-cart-drawer__items",
      },
      {
        id: "Drawer-Cart",
        section: "cart-drawer",
        selector: ".f-cart-drawer__block-subtotal",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
